import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { v4 as uuidv4 } from 'uuid';
import { MemberStateModel } from 'models/setting/member.model';
import {
  activeMemberAction,
  createMemberAction,
  deleteMemberAction,
  getMemberAction,
  inactiveMemberAction,
  listMemberAction,
  updateMemberAction,
} from './member.action';

const initialState: MemberStateModel = {
  memberListData: null,
  memberDetail: null,
  isTableSelectAllCheckbox: false,
  tableSelectCheckboxIds: [],

  triggerSaveMember: null,

  loadingList: false,
  loadingDetail: false,
};

export const memberSlice = createSlice({
  name: 'member',
  initialState,
  reducers: {
    setMemberStateAction: (
      state,
      action: PayloadAction<Partial<MemberStateModel>>,
    ) =>
      ({
        ...state,
        ...action?.payload,
      } as MemberStateModel),
    resetMemberStateAction: () => ({ ...initialState }),
  },
  extraReducers: (builder) => {
    builder
      .addCase(getMemberAction.pending, (state) => ({
        ...state,
        memberDetail: null,
        loadingDetail: true,
      }))
      .addCase(getMemberAction.fulfilled, (state, { payload }) => ({
        ...state,
        memberDetail: payload?.data || null,
        loadingDetail: false,
      }))
      .addCase(getMemberAction.rejected, (state) => ({
        ...state,
        memberDetail: null,
        loadingDetail: false,
      }))
      .addCase(listMemberAction.pending, (state) => ({
        ...state,
        loadingList: true,
      }))
      .addCase(listMemberAction.fulfilled, (state, { payload }) => ({
        ...state,
        loadingList: false,
        memberListData: {
          items: payload?.data?.items || [],
          totalItems: payload?.data?.totalItems || 0,
          totalPages: payload?.data?.totalPages || 0,
        },
      }))
      .addCase(listMemberAction.rejected, (state) => ({
        ...state,
        loadingList: false,
      }))
      .addCase(createMemberAction.fulfilled, (state) => ({
        ...state,
        triggerSaveMember: { id: uuidv4() },
      }))
      .addCase(updateMemberAction.fulfilled, (state) => ({
        ...state,
        triggerSaveMember: { id: uuidv4() },
      }))

      .addCase(deleteMemberAction.pending, (state) => ({
        ...state,
        loadingList: true,
      }))
      .addCase(deleteMemberAction.fulfilled, (state) => ({
        ...state,
        triggerSaveMember: { id: uuidv4() },
      }))
      .addCase(deleteMemberAction.rejected, (state) => ({
        ...state,
        loadingList: false,
      }))
      .addCase(activeMemberAction.fulfilled, (state) => ({
        ...state,
        triggerSaveMember: { id: uuidv4() },
        loadingList: false,
      }))
      .addCase(inactiveMemberAction.fulfilled, (state) => ({
        ...state,
        triggerSaveMember: { id: uuidv4() },
        loadingList: false,
      }));
  },
});

export const { setMemberStateAction, resetMemberStateAction } =
  memberSlice.actions;

export default memberSlice.reducer;
